<div class="w-full h-full z-99">
    <div class="w-full h-full board-with-nav">
        <nav class="bg-white shadow border-b" aria-label="nav">
            <div class="mx-auto px-4">
                <div class="flex justify-between h-16 my-auto">
                    <div class="flex gap-4 my-auto">
                        <div class="space-x-4 pl-4 ng-star-inserted">
                            <div class="flex items-center">
                                <span
                                    class="font-semibold text-2xl text-gray-700 cursor-pointer">{{'calendar.settings.calendar.title'
                                    | translate}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="sm:ml-6 sm:flex sm:items-center my-auto gap-6">
                        <div class="flex items-center justify-center">
                            <button (click)="createNewJob(null)"
                               [matTooltip]="buttonConfig?.toolTipText | translate"
                               class="flex items-center px-4 py-3 h-9 text-base font-medium bg-primary text-white"
                               [ngClass]="{'rounded-l-md  mr-0.5': (buttonConfig?.type === 'BUTTONGROUP'), 'rounded-md' : (buttonConfig?.type === 'BUTTON'), 'opacity-70 cursor-not-allowed':buttonConfig?.isDisabled, 'cursor-pointer':!buttonConfig?.isDisabled}">
                              {{buttonConfig.displayKey | translate}}
                              <em [ngClass]="{'opacity-70 cursor-not-allowed':buttonConfig?.isDisabled}" *ngIf="buttonConfig?.icon" class="text-base mr-2 text-white" ngClass="{{buttonConfig?.icon}}"></em>
                            </button>
                            <button *ngIf="buttonConfig?.type === 'BUTTONGROUP'"
                                  [matTooltip]="buttonConfig?.toolTipText | translate"
                                  [matMenuTriggerFor]="dropdown"
                                  [ngClass]="{ 'opacity-70 cursor-not-allowed':(buttonConfig?.isDropdownDisabled )}"
                                  class="h-9 flex items-center p-2 text-base font-medium text-center bg-primary text-white border border-l-0  rounded-r-md "
                                  type="button">
                              <em [ngClass]="{'opacity-70 cursor-not-allowed':buttonConfig?.isDropdownDisabled}" class="text-base  ti ti-chevron-down font-semibold"></em>
                            </button>
                            <mat-menu #dropdown="matMenu" class="buttongroup-dropdown">
                              <ng-container *ngFor="let option of buttonConfig?.children">
                                <div class="zuper-scrollbar">
                                  <a (click)="calendarActions(option)" [disabled]="!option.isEnabled" mat-menu-item class="primary-font text-base h-10 text-gray-700 flex">
                                    <span class="flex items-center" [ngClass]="{'space-x-2':option?.icon }">
                                        <em *ngIf="option?.icon" ngClass="{{option?.icon}}"></em>
                                        <span>{{option?.displayKey | translate}}</span>
                                    </span>
                                  </a>
                                </div>
                              </ng-container>
                            </mat-menu>
                          </div>
                        <button class="items-center hover:bg-gray-100 hover:text-gray-900 rounded-lg p-2"
                            (click)="openSettingsDialog('CALENDAR')" title="{{'text.settings' | translate}}">
                            <i class="ti ti-settings text-3xl"></i>
                        </button>
                    </div>
                </div>
            </div>
        </nav>
        <div class="bg-white shadow border-b h-full w-full"
            [ngClass]="showSidePanel? 'grid-container-show' : 'grid-container-hide'">
            <div *ngIf="showSidePanel" class="calendar-panel">
                <div [ngClass]="miniCalendarHide ? 'p-2' : 'cal-min-btn-hover p-2'">
                    <span [ngClass]="miniCalendarHide ? 'cal-min-btn' : 'cal-min-btn-left'">
                        <span *ngIf="miniCalendarHide" class="primary-font text-xl flex items-center">
                            <em (click)="toggleCalendar(true)"
                                class="ti ti-chevron-down text-base font-semibold text-xl min-cal-down-icon"></em>
                            <span class="mini-cal-hide-btn">
                                {{selectedMonth.split(' ')[0]}} {{selectedMonth.split(' ')[selectedMonth.split('
                                ').length-1]}}
                            </span>
                        </span>
                        <em (click)="toggleCalendar(false)" class="text-xl"
                            *ngIf="showCalendarPicker && !miniCalendarHide"
                            class="ti ti-chevron-up text-base font-semibold"></em>
                    </span>
                </div>
                <bryntum-date-picker *ngIf="showCalendarPicker && !miniCalendarHide" #datePicker
                    (onSelectionChange)="onSelectionChange($event)" (onDateChange)="datePickerDateChange($event)"
                    [config]="pickerConfig!" [date]="startDate" [activeDate]="activeDate"></bryntum-date-picker>
                <app-calendar-shimmer-effect
                    *ngIf="!showCalendarPicker && !miniCalendarHide"></app-calendar-shimmer-effect>
                <hr>
                <div style="overflow-y: auto;" [style.max-height.px]="maxDivHeight">
                    <div class="items-center">
                        <div class="quick-filter-dropdown-field">
                            <label
                                class="block text-base mb-2 font-medium text-gray-600">{{'quickFilter.addNew'
                                | translate}}</label>
                            <ng-select #quickFilter id="dispatch_filter_select" name="filter"
                                class="job-category-filter" [(ngModel)]="selectedQuickFilter" [multiple]="false"
                                [clearable]="false" [searchable]="false" [hideSelected]="false" [appendTo]="'body'"
                                [closeOnSelect]="true" (change)="onQuickFilterChange($event, false, false)"
                                [loading]="quickFilterLoading">
                                <ng-option [value]="'ALL'">{{'dispatchBoard.navbar.default_filter' |
                                    translate}}</ng-option>
                                <ng-option *ngFor="let filter of quickFilters"
                                    [value]="filter.filter_uid">{{filter.filter_name}}</ng-option>
                                <ng-template ng-footer-tmp>
                                    <button (click)="quickFilter.close();addNewJobCalendarFilter()" [value]="'ADD'"
                                        class="w-full sticky z-10 bottom-0 bg-card text-base px-1.5 py-2 hover:bg-gray-100">
                                        <div class="flex justify-between">
                                            <div><em class="ti ti-plus"></em> {{'dispatchBoard.navbar.filter.add_filter'
                                                | translate}}</div>
                                            <div class="mt-1"></div>
                                        </div>
                                    </button>
                                    <button (click)="quickFilter.close();manageQuickFilters()" [value]="'MANAGE'"
                                        class="w-full sticky z-10 bottom-0 bg-card text-base px-1.5 py-2 hover:bg-gray-100">
                                        <div class="flex justify-between">
                                            <div><em class="ti ti-settings"></em>
                                                {{'manage_filter.text' | translate}}</div>
                                            <div class="flex items-center"><em
                                                    class="ti ti-arrow-narrow-right font-medium text-xl"></em></div>
                                        </div>
                                    </button>
                                </ng-template>
                            </ng-select>
                        </div>
                    </div>
                    <div class="items-center h-full">
                        <div class="tab m-expand items-center">
                            <mat-expansion-panel expanded="true" (opened)="panelOpenState = true"
                                (closed)="panelOpenState = false">
                                <mat-expansion-panel-header>
                                    <mat-panel-title class="font-bold">
                                        {{'text.filters' | translate}}
                                    </mat-panel-title>
                                    <button
                                        class="text-sm font-semibold items-center border-gray-300 shadow-sm font-medium reset-btn"
                                        (click)="resetFilterForm($event)">{{'reset.text' |
                                        translate}}</button>
                                </mat-expansion-panel-header>
                                <form class="primary-font" autocomplete="off" [formGroup]="filterForm">
                                    <div>
                                        <!-- Job Category -->
                                        <div class="mb-4">
                                            <label class="block text-base mb-2 font-medium text-gray-600">
                                                {{'job.category' | translate}}
                                            </label>
                                            <ng-select class="job-category-filter" [items]="jobsCategory"
                                                bindLabel="category_name" bindValue="category_uid" [multiple]="true"
                                                [searchable]="true" appendTo="body"
                                                placeholder="{{'text.select_category' | translate}}"
                                                groupBy="selectedAllCategories" [selectableGroup]="true"
                                                (change)="changeJobCategory($event)" formControlName="jobCategory"
                                                [hideSelected]="false" [closeOnSelect]="false">
                                                <ng-template ng-optgroup-tmp let-item="item" let-item$="item$"
                                                    let-index="index">
                                                    <div class="primary-font text-base flex items-center">
                                                        <input id="item-{{index}}" type="checkbox" class="mr-2"
                                                            [checked]="item$.selected"
                                                            (change)="$event.stopPropagation()" />
                                                        {{'text.select_all_categories' | translate}}
                                                    </div>
                                                </ng-template>
                                                <ng-template ng-option-tmp let-item="item" let-item$="item$"
                                                    let-index="index">
                                                    <div class="primary-font text-base flex items-center">
                                                        <input id="item-{{index}}" type="checkbox" class="mr-2"
                                                            [checked]="item$.selected"
                                                            (change)="$event.stopPropagation()" />
                                                        {{item.category_name}}
                                                    </div>
                                                </ng-template>
                                                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                                    <div class="ng-value" *ngIf="items.length > 1">
                                                        <span class="primary-font ng-value-label text-base">
                                                            {{items.length}} {{'categories.selected.text'
                                                            |
                                                            translate}}</span>
                                                    </div>
                                                    <div class="ng-value" *ngIf="items.length === 1">
                                                        <span class="primary-font ng-value-label text-base">
                                                            {{items.length}} {{'Category Selected'
                                                            |
                                                            translate}}</span>
                                                    </div>
                                                </ng-template>
                                            </ng-select>
                                        </div>
                                        <div class="selected-items">
                                            <div *ngFor="let item of filteredJobCategoryArray" class="selected-item">
                                                {{ item.category_name }}
                                                <span (click)="removeJobCategoryItem(item)"
                                                    class="rounded-full flex justify-center items-center hover:bg-gray-200 h-5 w-5 p-1 cursor-pointer">
                                                    <em class="ti ti-x text-sm font-bold"></em>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="pt-4" *ngIf="filterForm.get('jobCategory')?.value?.length">
                                        <!-- Job Status -->
                                        <div class="mb-4">
                                            <label class="block text-base mb-2 font-medium text-gray-600">
                                                {{'text.job_status' | translate}}
                                            </label>
                                            <ng-select class="job-status-filter" [items]="jobsStatuses"
                                                bindLabel="status_name" bindValue="status_uid" [multiple]="true"
                                                [searchable]="true" appendTo="body"
                                                placeholder="{{'text.select_status' | translate}}"
                                                groupBy="category_name" (change)="changeJobStatus($event)"
                                                formControlName="jobStatus" [hideSelected]="false"
                                                [closeOnSelect]="false">
                                                <ng-template ng-header-tmp let-item="item">
                                                    <div class="primary-font text-base flex pl-5 items-center">
                                                        <input id="any_job_status" type="checkbox"
                                                            class="mr-2 cursor-pointer"
                                                            (change)="setAnyJobStatus($event)"
                                                            [checked]="isAnyStatus" />
                                                        <label for="any_job_status"
                                                            class="cursor-pointer">{{'text.select_all' |
                                                            translate}}</label>
                                                    </div>
                                                </ng-template>
                                                <ng-template ng-optgroup-tmp let-item="item">
                                                    <div class="primary-font text-lg font-bold">
                                                        {{item?.category_name}}
                                                    </div>
                                                </ng-template>
                                                <ng-template ng-option-tmp let-item="item" let-item$="item$"
                                                    let-index="index">
                                                    <div class="primary-font text-base flex items-center">
                                                        <input id="item-{{index}}" type="checkbox" class="mr-2"
                                                            [checked]="item$.selected"
                                                            (change)="$event.stopPropagation()" />
                                                        {{item.status_name}}
                                                    </div>
                                                </ng-template>
                                                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                                    <div class="ng-value" *ngIf="filteredStatusArray.length > 1">
                                                        <span class="primary-font ng-value-label text-base">
                                                            {{items.length}} {{'Statuses Selected'
                                                            |
                                                            translate}}</span>
                                                    </div>
                                                    <div class="ng-value" *ngIf="filteredStatusArray.length === 1">
                                                        <span class="primary-font ng-value-label text-base">
                                                            {{items.length}} {{'Status Selected'
                                                            |
                                                            translate}}</span>
                                                    </div>
                                                </ng-template>
                                            </ng-select>
                                        </div>
                                        <div class="selected-items">
                                            <div *ngFor="let item of filteredStatusArray" class="selected-item">
                                                {{ item.status_name }}
                                                <span (click)="removeStatusItem(item)"
                                                    class="rounded-full flex justify-center items-center hover:bg-gray-200 h-5 w-5 p-1 cursor-pointer">
                                                    <em class="ti ti-x text-sm font-bold"></em>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="pt-4">
                                        <!-- Teams -->
                                        <div class="mb-4">
                                            <label class="block text-base mb-2 font-medium text-gray-600">
                                                {{'text.teams' | translate}}
                                            </label>
                                            <ng-select class="job-category-filter" [items]="teams | async"
                                                [multiple]="true" [loading]="teamFetching" appendTo="body"
                                                [closeOnSelect]="false" [typeahead]="teamValueSubject"
                                                (open)="getAllTeams(false)" (clear)="onTeamClear()"
                                                (search)="onTeamSearch()" (change)="changeTeams($event)"
                                                (scrollToEnd)="onTeamScrollToEnd()" [searchable]="true" appendTo="body"
                                                placeholder="{{'text.select_teams' | translate}}" [clearable]="false"
                                                formControlName="teams" [hideSelected]="false">
                                                <ng-template ng-option-tmp let-item="item" let-item$="item$"
                                                    let-index="index">
                                                    <div class="primary-font text-base flex items-center">
                                                        <input id="item-{{index}}" type="checkbox" class="mr-4"
                                                            [checked]="isTeamAssigned(item)"
                                                            (change)="jobObject?.assigned_to?.length ? userSelectionChanged($event, item) : $event.stopPropagation()" />
                                                        <div class="primary-font text-base flex items-center">
                                                            <p>
                                                                {{item?.team_name}}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </ng-template>
                                                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                                    <div class="ng-value" *ngIf="items.length > 1">
                                                        <span class="primary-font ng-value-label text-base">
                                                            {{items.length}} {{'text.teams_selected'
                                                            |
                                                            translate}}</span>
                                                    </div>
                                                    <div class="ng-value" *ngIf="items.length === 1">
                                                        <span class="primary-font ng-value-label text-base">
                                                            {{items.length}} {{'text.team_selected'
                                                            |
                                                            translate}}</span>
                                                    </div>
                                                </ng-template>
                                            </ng-select>
                                        </div>
                                        <div class="selected-items">
                                            <div *ngFor="let item of filteredTeamsArray" class="selected-item">
                                                {{ item.team_name }}
                                                <span (click)="removeTeamItem(item)"
                                                    class="rounded-full flex justify-center items-center hover:bg-gray-200 h-5 w-5 p-1 cursor-pointer">
                                                    <em class="ti ti-x text-sm font-bold"></em>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="pt-4">
                                        <!-- Users -->
                                        <div class="mb-4">
                                            <label class="block text-base mb-2 font-medium text-gray-600">
                                                {{'text.users' | translate}}
                                            </label>
                                            <ng-select class="job-category-filter" [items]="employees | async"
                                                [multiple]="true" [loading]="employeeFetching" appendTo="body"
                                                [closeOnSelect]="false" [typeahead]="employeeValueSubject"
                                                (clear)="onEmployeeClear()" (search)="onEmployeeSearch()"
                                                (open)="getAllEmployees(false)" (change)="changeUsers($event)"
                                                (scrollToEnd)="onEmployeeScrollToEnd()" [searchable]="true"
                                                appendTo="body" placeholder="{{'text.select_users' | translate}}"
                                                [clearable]="false" formControlName="employees" [hideSelected]="false">
                                                <ng-template ng-option-tmp let-item="item" let-item$="item$"
                                                    let-index="index">
                                                    <div class="primary-font text-base flex items-center">
                                                        <input id="item-{{index}}" type="checkbox" class="mr-4"
                                                            [checked]="isEmployeeAssigned(item)"
                                                            (change)="jobObject?.assigned_to?.length ? userSelectionChanged($event, item) : $event.stopPropagation()" />
                                                        <div class="primary-font text-base flex items-center">
                                                            <p>
                                                                {{item.first_name}} {{item.last_name ?? ''}}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </ng-template>
                                                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                                    <div class="ng-value" *ngIf="items.length > 1">
                                                        <span class="primary-font ng-value-label text-base">
                                                            {{items.length}}
                                                            {{'dispatch.filter.applicability_users.selected_text'
                                                            |
                                                            translate}}</span>
                                                    </div>
                                                    <div class="ng-value" *ngIf="items.length === 1">
                                                        <span class="primary-font ng-value-label text-base">
                                                            {{items.length}}
                                                            {{'dispatch.filter.applicability_user.selected_text'
                                                            |
                                                            translate}}</span>
                                                    </div>
                                                </ng-template>
                                            </ng-select>
                                        </div>
                                        <div class="selected-items">
                                            <div *ngFor="let item of filteredEmployeesArray" class="selected-item">
                                                {{item.first_name}} {{item.last_name}}
                                                <span (click)="removeEmployeeItem(item)"
                                                    class="rounded-full flex justify-center items-center hover:bg-gray-200 h-5 w-5 p-1 cursor-pointer">
                                                    <em class="ti ti-x text-sm font-bold"></em>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </mat-expansion-panel>
                        </div>
                        <div class="items-center w-filter-95">
                            <button mat-stroked-button
                                class="text-center border-none ml-4 bg-color-orange rounded-none cursor-pointer ad-h-32 ad-w-inherit text-base text-orange-600 font-semibold"
                                (click)="openJobCalendarFilter('GRID')">
                                {{'calendar.home.tab.advancedfilters' | translate}}
                                <badge *ngIf="advancedFilterCount > 0" [options]="getFilterCountOptions()"
                                    class="ml-1 primary-font"></badge>
                            </button>
                        </div>
                    </div>
                    <div [ngClass]="calendarMode === 'month' ? 'cursor-not-allowed md:cursor-auto': ''">
                        <div class="tab m-expand items-center">
                            <mat-expansion-panel expanded="true" (opened)="panelOpenState = true"
                                (closed)="panelOpenState = false">
                                <mat-expansion-panel-header>
                                    <mat-panel-title class="font-bold">
                                        {{'caledar.home.tab.cellcontrol' | translate}}
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <div class="pt-2">
                                    <div>
                                        {{'calendar.home.tab.height' | translate}}
                                    </div>
                                    <div class="pt-2"
                                        [ngClass]="{'disable-scroller' : calendarMode === 'month' || calendarMode === 'agenda'}">

                                        <app-custom-slider [sliderValue]="sliderHeightValue" [sliderType] = "'HEIGHT'"
                                            (sliderValueChanged)="onSliderValueChanged($event)"></app-custom-slider>
                                    </div>
                                </div>
                                <div class="pt-4">
                                    <div>
                                        {{'calendar.home.tab.width' | translate}}
                                    </div>
                                    <div class="pt-2"
                                        [ngClass]="{'disable-scroller' : calendarMode === 'month' || calendarMode === 'agenda'}">

                                        <app-custom-slider [sliderValue]="sliderWidthValue" [sliderType] = "'WIDTH'"
                                            (sliderValueChanged)="onSliderValueChanged($event)"></app-custom-slider>
                                    </div>
                                </div>
                            </mat-expansion-panel>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-full w-full">
                <div class="mx-auto pr-1rem">
                    <div class="flex justify-between h-20 my-auto">
                        <div (click)="toggleSidePanel()" class="cal-collap">
                            <img class="cal-collaps-btn" [src]="showSidePanel ? 'assets/images/svgs/toggle-right.svg' : 'assets/images/svgs/toggle-left.svg'" alt="">
                        </div>
                        <div class="flex gap-4 my-auto">
                            <div class="space-x-4 pl-4 ng-star-inserted">
                                <div class="cal-pag-event flex items-center justify-between">
                                    <button
                                        class="mr-3 bg-card px-4 py-2 border border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none today-text"
                                        (click)="goTocalendar('today')">{{'daterange.range.today.label' |
                                        translate}}</button>

                                    <div class="flex items-center">
                                        <button class="hover:bg-gray-100 hover:text-gray-900 rounded-lg p-2"
                                            (click)="goTocalendar('prev')">
                                            <img src="assets/images/svgs/angle-right.svg" alt="">
                                        </button>
                                        <button class="hover:bg-gray-100 hover:text-gray-900 rounded-lg p-2"
                                            (click)="goTocalendar('next')">
                                            <img src="assets/images/svgs/angle-left.svg" alt="">
                                        </button>
                                    </div>

                                    <div class="cal-date-desc" *ngIf="selectedDate">
                                        {{ selectedDate }}
                                        <span class="weekNumber"
                                            *ngIf="(calendarMode === 'day' || calendarMode === 'week') && metaData?.calendar?.display?.week_numbers">
                                            {{'calendar.home.tab.week' | translate}} {{weekNumber}}
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="sm:ml-6 sm:flex sm:items-center my-auto gap-6">
                            <div class="flex quickFilter">
                                <div class="p-1 mr-3 ">
                                    <button [ngxTippy]="calendarSearch" [tippyProps]="calendarSearchTippyProps"
                                        [tippyName]="'tippycalendarSearch'"
                                        class="hover:bg-gray-100 hover:text-gray-900 rounded-lg relative h-10 p-2"
                                        title="{{'text.search' | translate}}">
                                        <i class="ti ti-search text-3xl text-gray-900"></i>
                                        <div *ngIf="calendarSearchKeyword"
                                            class="absolute inline-flex items-center justify-center w-3 h-3 text-xs font-bold text-white bg-primary-600 border-2 border-white rounded-full top-0 -right-1 dark:border-gray-900">
                                            </div></button>
                                </div>
                                <!-- <div class="relative flex  sm:items-center p-2 items-start">
                                    <div class="flex h-6 items-center">
                                        <input type="checkbox" name="autoHeight"  class="h-4 w-4 rounded border-gray-300 text-indigo-600" [disabled]="autoRowHeight"  (change)="onAutoRowHeightChanged($event)">
                                    </div>
                                    <div class="ml-3 text-sm leading-6">
                                      <label for="candidates" class="font-medium text-gray-900">Auto Row Height</label>
                                    </div>
                                  </div> -->
                                <nav class="cal-nav-btn" aria-label="Tabs" [ngClass]="disableModeTab ? 'cursor-not-allowed md:cursor-auto' : ''">
                                    <a class="cal-btn"
                                        [ngClass]="calendarMode === 'month' ? 'cal-btn cal-btn-active': 'cal-btn'"
                                        (click)="changeCalendarMode('month')">{{'calendar.home.tab.month' |
                                        translate}}</a>
                                    <a class="cal-btn"
                                        [ngClass]="calendarMode === 'week' ? 'cal-btn cal-btn-active': 'cal-btn'"
                                        (click)="changeCalendarMode('week')">{{'calendar.home.tab.week' |
                                        translate}}</a>
                                    <a class="cal-btn"
                                        [ngClass]="calendarMode === 'day' ? 'cal-btn cal-btn-active': 'cal-btn'"
                                        (click)="changeCalendarMode('day')">{{'text.day' | translate}}</a>
                                    <!-- <a class="cal-btn"
                                        [ngClass]="calendarMode === 'agenda' ? 'cal-btn cal-btn-active': 'cal-btn'"
                                        (click)="changeCalendarMode('agenda')">List</a> -->
                                </nav>
                                <div class="mr-3 ml-3">
                                    <button type="button" class="rounded-md unscheduled-btn-height px-3.5 py-2.5 text-base font-medium 
                                    shadow-sm" (click)="openGridDrawer()"
                                        [ngClass]="grid.unscheduledJobcount > 0 ? 'text-error-secondary': 'ring-1 ring-inset ring-gray-300 hover:bg-gray-50'">
                                        {{ 'text.unscheduled.jobs' | translate}} <span
                                            *ngIf="grid.unscheduledJobcount">({{grid.unscheduledJobcount}})</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="h-1 w-full" *ngIf="!loaded" style="position: absolute;">
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </div>
                <hr>
                <div class="h-full w-full " [ngClass]="gridDrawerOptions.show? 'calendar-grid-show':''">
                    <div class="h-full w-full grid grid-cols-1 calendar-wrapper">
                        <bryntum-calendar #calendar id="zuper-calendar" [timeZone]="calendarConfig?.timeZone" [events]="events" 
                            [date]="calendarConfig.date!" [modes]="calendarConfig.modes!" [tbar]="calendarConfig.tbar!"
                            [config]="calendarConfig"></bryntum-calendar>
                    </div>
                    <div [hidden]="!gridDrawerOptions.show" class="grid grid-cols-1 w-full h-full border-gray-200 border-l-2">
                        <div>
                                            <!-- Header -->
                        <div class="w-full h-16 py-2 px-4 flex items-center justify-between border-b border-gray-200">
                            <span class="font-semibold text-xl text-gray-600">{{'text.unscheduled.jobs'
                                | translate}}</span>
                            <button mat-icon-button tabindex="0" (click)="closeGridDrawer()">
                                <em class="ti ti-x icon-size-7 text-gray-500"></em>
                            </button>
                        </div>

                        <!-- Grid -->
                        <div class="g-h-auto w-full overflow-y-auto">
                            <bryntum-grid #gridView id="grid-card-view" [data]="grid.unscheduledJobs" [cls]="'min-h-0'"
                                [bodyCls]="'h-full'"
                                [emptyText]="_utilityService.getLocaleValue('text.no_jobs_found', 'No Jobs Found')"
                                [config]="gridCardConfig" [stripeFeature]="false">
                            </bryntum-grid>

                        </div>
                        <footer class="flex flex-col bg-white z-99 w-full  border-t border-gray-200 overflow-x-auto">
                            <div
                                class="flex gap-4 justify-between bg-white p-1 h-18 w-full border-b px-4 align-center items-center">
                                <div class="flex gap-3 items-center">
                                    <span>{{totalGridRecords}} {{'text.jobs' | translate}}</span>
                                    <div class="flex items-center pageNumber">
                                        <mat-form-field appearance="fill" class="w-16">
                                            <input inputmode="numeric"
                                                oninput="this.value = this.value.replace(/^0+/,'').replace(/\D+/g, '')"
                                                [(ngModel)]="gridPageNumber"
                                                (keyup.enter)="updateGridPageNumber($event)" matInput>
                                        </mat-form-field>
                                    </div>
                                    <span>{{'of' | translate}} {{totalGridPage}} {{'text.pages' | translate}}</span>
                                </div>
                                <div class="flex items-center justify-between mt-1.5">
                                    <button [disabled]="currentPageNumber === 1" (click)="gridPageIncrement('prev')"
                                        class="hover:bg-gray-100 hover:text-gray-900 rounded-lg h-10 p-2"
                                        title="{{'dispatchBoard.icons.tooltip.prev_page' | translate}}" [ngClass]="currentPageNumber === 1 ? 'disable-scroller': ''">
                                        <i class="ti ti-chevron-left text-3xl btnColor-black"></i></button>
                                    <button [disabled]="totalGridPage === 1 || totalGridPage === currentPageNumber"
                                        (click)="gridPageIncrement('next')"
                                        class="hover:bg-gray-100 hover:text-gray-900 rounded-lg h-10 p-2"
                                        title="{{'dispatchBoard.icons.tooltip.next_page' | translate}}" [ngClass]="totalGridPage === 1 || totalGridPage === currentPageNumber ? 'disable-scroller': ''">
                                        <i class="ti ti-chevron-right text-3xl btnColor-black"></i></button>
                                </div>
                            </div>
                        </footer>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</div>



<!-- Job preview -->
<preview-data [drawerOpen]="openDrawer" [previewDrawerName]="'dispatch_preview'" [module]="'JOB'" [hidden]="!openDrawer"
    [moduleUID]="getModuleID()" [options]="previewDataOptions" (eventEmitter)="previewDataEventHandler($event)">
</preview-data>

<!-- New Job Form -->
<app-new-job [openDrawer]="openNewJobDrawer" [timezone]="getDispatchTimeZoneObj()" [jobObject]="newJobPrefillData"
    [jobData]="cloneJobData" (jobFormEmitter)="jobFormEmitHandler($event)"></app-new-job>

<!-- New Non Job Event Form -->
<create-non-job-event [openDrawer]="nonJobEventCreateDrawerData?.openDrawer" [timezone]="selectedTimeZone" [options]="nonJobEventCreateDrawerData?.options"
    [eventData]="nonJobEventCreateDrawerData?.eventData" (actionEmitter)="nonJobEventEmitHandler($event)"></create-non-job-event>

<!-- Non nob event details -->
<non-job-event-details [nonJobEventUid]="nonJobEventDetailsDrawerData?.nonJobEventUid" [openDrawer]="nonJobEventDetailsDrawerData?.openDrawer" [options]="nonJobEventDetailsDrawerData?.options" 
    [drawerName]="nonJobEventDetailsDrawerData?.drawerName" [timezone]="selectedTimeZone" (actionEmitter)="nonJobEventDetailsDrawerEmitter($event)"></non-job-event-details>

<!-- calendar filter drawer -->
<app-calendar-filter-drawer class="dispatch-board-filter"
    [saveFilterByDefault]="calendarFilterDrawerData.saveFilterByDefault"
    [jobCalendarFilterValues]="calendarFilterDrawerData.jobCalendarFilterValues"
    [openFilter]="calendarFilterDrawerData.openFilter" [hideSaveFilter]="calendarFilterDrawerData.hideSaveFilter"
    [ngClass]="{'-z-1': !calendarFilterDrawerData.openFilter, 'z-auto': calendarFilterDrawerData.openFilter }"
    (filterDrawerEmitter)="filterDrawerEmitter($event)"></app-calendar-filter-drawer>


<!-- calendar search tippy -->
<ng-template #calendarSearch let-hide>
    <div class="w-80 h-20 flex">
        <div class="flex items-center justify-center gap-3 p-3 w-full">
            <mat-form-field appearance="fill" class="w-full">
                <input matInput [(ngModel)]="calendarSearchKeyword"
                    placeholder="{{'dispatchBoard.grid.tbar.job_search_placeholder' | translate}}"
                    (keyup)="applyCalendarSearch($event)">
                <button *ngIf="calendarSearchKeyword" matSuffix mat-icon-button aria-label="Clear"
                    (click)="calendarSearchKeyword=''; applyCalendarSearch($event, 'clear')">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
    </div>
</ng-template>

<!-- calenar holiday popup  -->
<ng-template #calendarHolidayDialog let-hide let-data>
    <div class="flex justify-between border-b border-b-gray-300 calendar-holiday-dialog-header">
        <h4>{{'calendar.holiday.title' | translate}}</h4>
        <button mat-icon-button aria-label="close dialog" (click)="closeCalendarEventDialog()" tabindex="-1">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="calendar-holiday-dialog-body">
        <div class="flex items-center space-x-3 max-w-96" *ngIf="data.blockJobsOnHoliday">
            <i class="ti ti-alert-triangle text-red-500 text-3xl cursor-default"></i>
            <span
                class="text-red-500 font-medium text-base cursor-default">{{'dispatchBoard.scheduler.error.block_new_job_on_holiday'
                | translate}} : {{data.holidayName}}</span>
        </div>
    </div>

</ng-template>

